import React, { Component } from "react";
import Layout from "@pages/candidate/Layout";
import {
    Heading, 
    Container, 
    Button,
    Box,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";

import { Separator, View, OffersSearch, OfferItem, OfferSkeleton, LoadMore } from '@components';
import { generateQuery } from "@lib/functions";
import { getOffers, searchOffers } from "@lib/datahandlers/person";
import { t } from '@lang/i18n';
import { AuthContext } from '@contexts/AuthContext';
import { PER_PAGE } from '@lib/constants';

class OffersScreen extends Component{
    static contextType = AuthContext;

    state = {
        account_completed: true,
        filters_open: false,
        loading_more: false,
        has_more: true,
        loading: false,
        offers: [],
        params: {},
        // page: 1,
        load_more_page: 1
    };

    componentDidMount() {
        document.title = t('candidate.search_job.main.page_title');;
        // complete account
        this.setState({
            account_completed: this.context.auth.user_data.completed
        })
    }

    // getOffers = async (params = {}) => {
    //     this.setState({loading: true});
    //     const response = await getOffers({...params, page: this.state.page});
    //     this.setState({loading: false});

    //     if (response) {
    //         this.setState({
    //             offers: response.offers,
    //             has_more: response.offers.length === PER_PAGE,
    //         });
    //         return;
    //     }
    // };

    search_offers = async (params = {}) => {
        this.setState({loading: true});

        const PARAMS = ['address', 'longitude', 'latitude', 'city', 'department', 'region', 'fonctions', 'contracts', 'activities', 'salary_min'];
        const baseUrl = '/offers/search';
        const filters = generateQuery(PARAMS, params, this.state.load_more_page, baseUrl)

        const response = await searchOffers(filters);
        this.setState({loading: false});

        if (response) {
            this.setState({
                offers: response.offers,
                has_more: response.offers.length === PER_PAGE,
            });
            return;
        }
    }

    onSearch = (params) => {
        this.setState({params});
        this.search_offers({
            fonctions:  params.selected_fonctions.map(e=>e.value).join(',') || undefined,
            activities: params.selected_activities.map(e=>e.value).join(',') || undefined,
            contracts:  params.selected_contracts .map(e=>e.value).join(',') || undefined,
            longitude:  params.longitude  + ""   || undefined,
            latitude:   params.latitude   + ""   || undefined,
            department: params.department + "" || undefined,
            region: params.region + "" || undefined,
            city: params.city +"" || undefined,
            salary_min: params.salary_min * 1000 || undefined,
        });
    }

    showMore = async () => {
        let nextPage = this.state.load_more_page + 1;

        const filters = { ...this.state.params };
        const PARAMS = ['address', 'longitude', 'latitude', 'city', 'department', 'region', 'fonctions', 'contracts', 'activities', 'salary_min'];
        const baseUrl = '/offers/search';
        const searchQuery = generateQuery(PARAMS, filters, nextPage, baseUrl); 

        this.setState({ loading_more: true });
        const response = await searchOffers(searchQuery);
        this.setState({ loading_more: false });

        if (response) {
            this.setState({
                offers: [...this.state.offers, ...response.offers], 
                has_more: response.offers.length === PER_PAGE,
                page: nextPage,
            });
            return;
        }
    }

    toggleFilters = () => {
        this.setState({filters_open: !this.state.filters_open});
    }    
    
    
    render(){ 
        return (
        <Layout menuType="candidate" isNavBarVisible isFooterVisible>
            <Container maxW="container.md" bg="#FFFC" minHeight='calc(100vh - 100px)' py="36px" px={["16px","","","100px"]} >
                <Heading textAlign="center" fontSize="30px" m="auto" maxW="435px"> {t('candidate.search_job.main.title')} </Heading>

                <Separator />
                
                {/* Complete your account */}
                <View if={!this.state.account_completed}>
                    <Box m="auto" textAlign="center">
                        <Heading m="auto" mt="180px" maxW="600px" fontWeight="500" fontSize="20px">
                            {t('candidate.search_job.main.profile_incompleted')}
                        </Heading>

                        <Link to="/candidate/profile">
                            <Button 
                                bg="blue.main"
                                _hover={{opacity: .8}}
                                lineHeight="30px"
                                color="white" 
                                fontWeight="normal" 
                                borderRadius="99" 
                                m="auto" mt="40px" p="0 30px"
                                letterSpacing="1px">
                                {t('candidate.search_job.main.complete_profile')}
                            </Button>
                        </Link>
                    </Box>
                </View>

                {/* Account completed */}
                <View if={this.state.account_completed}>
                    {/* Search */}
                    <OffersSearch onSearch={this.onSearch} display="flex" params={this.state.params}/>

                    {/* No results */}
                    <View if={!this.state.offers.length && !this.state.loading}>
                        <Box m="auto" textAlign="center">
                            <Heading m="auto" mt="80px" maxW="600px" fontWeight="500" color="#999" fontSize="20px">
                                {t('candidate.search_job.main.search_none')}
                            </Heading>
                        </Box>
                    </View>

                    {/* Loading */}
                    <View if={this.state.loading}
                        className={'fadeIn'}
                        mx="-17px"
                        display="flex" 
                        flexDir="row"
                        flexWrap="wrap" 
                        justifyContent={["center","","","space-between"]} >
                        {[1,2,3].map(e=>(<OfferSkeleton key={e} />))}

                    </View>

                    {/* Listing */}
                    <View if={this.state.offers.length && !this.state.loading} 
                        mx="-17px"
                        display="flex" 
                        flexDir="row"
                        flexWrap="wrap" 
                        justifyContent={["center","","","space-between"]} >

                        {/* Number of results */}
                        <Heading flexBasis="100%" textAlign={["center","","","left"]} fontWeight="600" fontSize="16px" ml="14px"> 
                            {this.state.offers.length} {t('candidate.search_job.main.available_offers')} 
                        </Heading>

                        {/* Results */}
                        {this.state.offers.map((offer, index) => (
                            <OfferItem key={index} data={offer} />
                        ))}

                        {/* Pagination */}
                        <View if={this.state.has_more} flexBasis="100%" textAlign="center">
                            <LoadMore showMore={() => this.showMore()} loading_more={this.state.loading_more} />
                        </View>
                    </View>

                </View>
            </Container>
        </Layout>
    )}
}

export default OffersScreen;